module.exports = __webpack_public_path__ + "img/pic1.8ed8ad5b.png";